export const SERVICE_UNAVAILABLE_STATUS = 503

export type VehicleService = 'navigation' | 'focus'

export const httpStatus = (error: unknown): number | undefined => {
  if (!error || typeof error !== 'object' || !('httpStatus' in error)) return undefined
  return typeof error.httpStatus === 'number' ? error.httpStatus : undefined
}

export const isServiceUnavailable = (error: unknown) => httpStatus(error) === SERVICE_UNAVAILABLE_STATUS

export const withHttpStatus = (error: unknown, status: number) => {
  if (error && typeof error === 'object' && !Array.isArray(error)) {
    return { ...error, httpStatus: status }
  }
  return { httpStatus: status }
}
